import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdDirective } from './ad.directive';
import { EventService } from './event.service';
import { OverlayContainerComponent } from './overlay-container.component';
import { Overlay } from './overlay.service';

@NgModule({
  imports: [CommonModule, OverlayContainerComponent, AdDirective],
  exports: [],
  providers: [Overlay, EventService],
  bootstrap: [],
})
export class OverlayModule {}
